import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  Typography,
  Grid,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { decupleBuyerStatus } from "../_helpers";
import { toastActions } from "../_actions";
import ConfirmBox from "../components/ConfirmBox";

const DecoupleBuyerDialog = ({ open, onClose, buyer, onExecute }) => {
const { t } = useTranslation();
const dispatch = useDispatch();
const [p1, setP1] = useState(!!buyer?.p1);
const [p2, setP2] = useState(!!buyer?.p2);
const [status, setStatus] = useState(decupleBuyerStatus.unSold);
const { selected } = useSelector((state) => state.buildings);
const [openConfirm, setOpenConfirm] = useState(false);


  console.log("buyer", buyer);

  const isIndividual = buyer?.type === 0;
  //TODO: Show status which time should be shown confirm with abhishek
  const showStatus = !isIndividual || p1 || !p2 ;

    if (!buyer) {
      return [];
    }

   const handleExecute = () => {
    if (isIndividual && !p1 && !p2) {
     dispatch(toastActions.error(t("buyersGuide.buyerActions.decuple.errorToastMessage")));
      return;
    }
    setOpenConfirm(true);
    onExecute({ removeP1: p1, removeP2: p2 });
};

const handleConfirmRemove = () => {
  dispatch(
    toastActions.success(
      t("buyersGuide.buyerActions.decouple.toastRemoved"))
  );

  setOpenConfirm(false);
  onClose();
};

  return (
    <Dialog open={open} onClose={(event, reason) =>reason === 'backdropClick' ? event.stopPropagation() : onClose() } fullWidth maxWidth="sm">
      <DialogTitle>{t("buyersGuide.buyerActions.decouple")}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 5 }}>
            <Typography> {t("general.buildingNumber")} </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 7 }}>
            <TextField
              size="small"
              fullWidth
              disabled
              value={selected?.buildingNoIntern || ""}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 5 }}>
            <Typography>{t("general.buyerRenter")}</Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 7 }}>
            <TextField
              size="small"
              fullWidth
              disabled
              value={
                buyer?.type === 1
                  ? buyer?.org?.name || ""
                  : `${buyer?.p1?.lastName || ""} ${buyer?.p2?.lastName || ""}`
              }
            />
          </Grid>

          {isIndividual && buyer?.p1 && (
            <>
              <Grid size={{ xs: 12, sm: 5 }}>
                <Typography>
                  {t("buyersGuide.buyerActions.decouple.disconnectPerson1")}:
                </Typography>
              </Grid>

              <Grid
                size={{ xs: 2, sm: 1 }}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Checkbox
                  size="small"
                  checked={p1}
                  onChange={(e) => setP1(e.target.checked)}
                />
              </Grid>

              <Grid size={{ xs: 10, sm: 6 }}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  value={`${buyer.p1.lastName}, ${buyer.p1.firstName}`}
                />
              </Grid>
            </>
          )}

          {isIndividual && buyer?.p2 && (
            <>
              <Grid size={{ xs: 12, sm: 5 }}>
                <Typography>
                  {t("buyersGuide.buyerActions.decouple.disconnectPerson2")}:
                </Typography>
              </Grid>

              <Grid
                size={{ xs: 2, sm: 1 }}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Checkbox
                  size="small"
                  checked={p2}
                  onChange={(e) => setP2(e.target.checked)}
                />
              </Grid>

              <Grid size={{ xs: 10, sm: 6 }}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  value={`${buyer.p2.lastName}, ${buyer.p2.firstName}`}
                />
              </Grid>
            </>
          )}
          {showStatus && (
            <>
              <Grid size={{ xs: 12, sm: 5 }}>
                <Typography>{t("general.status")}</Typography>
              </Grid>

              <Grid size={{ xs: 12, sm: 7 }}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  {Object.values(decupleBuyerStatus).map((val) => (
                    <MenuItem key={val} value={val}>
                      {t(`buyersGuide.buyerActions.decouple.status.${val}`)}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={handleExecute}>
          {t("general.task.execute")}
        </Button>
        <Button onClick={onClose}> {t("general.cancel")} </Button>
      </DialogActions>
      <ConfirmBox
        open={openConfirm}
        title={t("general.warning")}
        description={
          t("buyersGuide.buyerActions.decouple.confirmMessage")
        }
        okText={t("general.confirm")}
        cancelText={t("general.cancel")}
        onOk={handleConfirmRemove}
        onCancel={() => setOpenConfirm(false)}
      />
    </Dialog>
  );
};

export default DecoupleBuyerDialog;
